import classNames from 'classnames';

import { t } from '../../common/i18n/index.js';
import type { ProductAvailability } from '../DeviceDetailsCoCo/deviceDetailsUtilsCoCo.js';

import './ProductAvailabilityCoCo.scss';

export interface ProductAvailabilityCoCoProps {
  availability?: ProductAvailability | null;
  className?: string;
}

export const ProductAvailabilityCoCo = ({ availability, className }: ProductAvailabilityCoCoProps) => {
  if (!availability) {
    return null;
  }

  return (
    <div className={classNames('of-product-availability', className)}>
      {availability.color && (
        <>
          <label>{t.VC3L('Availability:')}</label>
          <span
            className={`of-product-availability__icon of-product-availability__icon--${availability.color}`}
            data-testid={`availability-${availability.color}`}
          />
        </>
      )}
      <span>{availability.text}</span>
    </div>
  );
};
